import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './318656bf31f25f83f059d610af54921a0f002ecfb0a25d848db38a702ec9c688.cfe-internal.js';
import { useInputGroupContext } from './fc923f7df98798752b55075d988c99381886b50e072df75d1b96be0b82f76494.cfe-internal.js';

var _excluded = ["children", "className", "small"];
var InputGroupAddon = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    rest = _objectWithoutProperties(_ref, _excluded);
  var inputGroupContext = useInputGroupContext();
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.addon, inputGroupContext.className, _defineProperty({}, styles.small, inputGroupContext.applySmall(small)))
  }), children);
});

export { InputGroupAddon as default };
